<template>
    <v-app id="app">
        <!-- App bar -->
        <v-app-bar app clipped-right color="bal-gray" light flat>
            <v-app-bar-nav-icon large @click.stop="toggleDrawer"/>
            <v-toolbar-title>{{ `${$route.meta.title}` | t }}</v-toolbar-title>

            <button class="custom-filter-btn ml-6" v-if="firstLoadingDone" @click="toggleFilterVisible">
                <i class="material-icons">filter_list</i>
                <span>{{ "Filter" | t }}</span>
            </button>
        </v-app-bar>

        <!-- Drawer left -->
        <main-drawer :drawer-open="mainDrawerOpen" @close="toggleDrawer"/>

        <!-- Main content -->
        <v-main>
            <router-view/>
        </v-main>

        <v-snackbar color="error" bottom :value="requestError">
            <div style="display: flex; flex-direction: row;">
                <v-icon color="#FFF">error</v-icon>
                <div class="title pa-2 ">{{ errorMsg }}</div>
            </div>
        </v-snackbar>

        <!-- Footer -->
        <page-footer/>
    </v-app>
</template>
<script>
import MainDrawer from "../components/main-drawer.vue";
import PageFooter from "../components/page-footer.vue";
import {mapState, mapMutations} from "vuex";
import ProductionAnalysisView from "@/pages/production-analysis/production-analysis-view.vue";

export default {
    name: "production-analysis-layout",
    components: {
        ProductionAnalysisView,
        PageFooter,
        MainDrawer
    },
    data() {
        return {
            mainDrawerOpen: null,
            error: false
        };
    },
    mounted() {
        document.addEventListener("keydown", this.handleKeyboardListener);
        const drawerState = localStorage.getItem("mainDrawerOpen");
        if (drawerState) {
            this.mainDrawerOpen = JSON.parse(drawerState);
        } else {
            this.mainDrawerOpen = true;
        }
    },
    beforeDestroy() {
      this.resetView()
    },
    computed: {
        ...mapState("ProductionAnalysisStore", ["requestError", "errorMsg", "firstLoadingDone"]),
    },
    watch: {
        requestError: value => {
            if (value)
                setTimeout(() => {
                    this.setRequestError(false)
                    this.setErrorMessage("")
                }, 3500);
        }
    },
    methods: {
         ...mapMutations("ProductionAnalysisStore", ["setErrorMessage", "setRequestError", "toggleFilterVisible", "resetView"]),
        toggleDrawer() {
            this.mainDrawerOpen = !this.mainDrawerOpen;
            localStorage.setItem("mainDrawerOpen", this.mainDrawerOpen);
        },
    },
};
</script>

<style scoped>
.custom-filter-btn {
    height: 36px;
    border-radius: 8px;
    padding: 7px 12px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 6px;
    background-color: white;
    cursor: pointer;
    font-family: inherit;
    color: black;
    text-transform: none;
    box-shadow: none;
}

.custom-filter-btn i {
    color: gray;
    font-size: 20px;
}

.custom-filter-btn:hover {
    background-color: #f5f5f5;
}
</style>
